import { render, staticRenderFns } from "./ListScientific_boss.vue?vue&type=template&id=1d9bef00&scoped=true"
import script from "./ListScientific_boss.vue?vue&type=script&lang=js"
export * from "./ListScientific_boss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9bef00",
  null
  
)

export default component.exports